import { PendStatuses } from "types";

const loadPendStatuses = async () => {
	try {
		const pendStatuses = await PendStatuses.getOptions({
			predicate: item => item.name !== "closed",
		});

		return {
			options: pendStatuses,
			hasMore: false,
		};
	} catch {
		return { options: [] };
	}
};

const pendStatusColumn = () => ({
	name: "pendStatus",
	type: "select" as const,
	loadOptions: loadPendStatuses,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Pend Status",
});

export default pendStatusColumn;
